"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureSchema = exports.accountFeatureSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const featureTypeArray = [
    'Google Search (cb_search_intent)',
    'Search & Message Bot (cb_message_search_only)',
    'Message (cb_message_intent)',
    'RASA (Machine learning model for FAQs)'
];
const featureType = [...featureTypeArray];
exports.accountFeatureSchema = yup_lib_1.default.string().oneOf(featureTypeArray).required();
exports.featureSchema = yup_lib_1.default.object().shape({
    feature: yup_lib_1.default.string().oneOf(featureTypeArray).required()
});
